import React, { PropTypes } from 'react'
import classnames from 'classnames'

const PlayerRow = ({
  player,
  key
}) => {
  return (
    <tr key={key}>
      <td className="name"><a href={player.href || '#'} dangerouslySetInnerHTML={{ __html: player.name }}></a></td>
      <td className="role">{player.role}</td>
    </tr>
  )
}

export class SquadTabs extends React.Component {

  constructor(props) {
    super(props)
    this.state = { active: 'a' }
  }

  static propTypes = {
    children: PropTypes.object
  }

  switchTab(tab) {
    this.setState({
      active: tab
    })
  }

  render() {
    const { active = 'a' } = this.state
    const { home = { players:[] }, away = { players:[] } } = this.props
    const homePlayersLen = home.players.length || 0
    const awayPlayersLen = away.players.length || 0

    const squadTabs = (
      <article className="boxscore-tabs sub-module-mobile-combine-split combined squad" data-behavior="content_tab_mobile">
        <header className="bordered">
            <h1>Squad</h1>
        </header>
        <div className="filter form-group button-group">
            <button onClick={this.switchTab.bind(this, 'a')} className={classnames('button-filter-alt lg fixed', { active: active == 'a' }, { 'disabled': home.isDisabledTab })} disabled={home.isDisabledTab}><span className="team-name">{home.name || ''}</span><span className="team-name-short">{home.shortName || home.name || ''}</span></button>
            <button onClick={this.switchTab.bind(this, 'b')} className={classnames('button-filter-alt lg fixed', { active: active == 'b' }, { 'disabled': away.isDisabledTab })} disabled={away.isDisabledTab}><span className="team-name">{away.name || ''}</span><span className="team-name-short">{away.shortName || away.name || ''}</span></button>
        </div>
        <div className="row-wrapper">
          <div className="content-tab" style={{ display: active == 'a' ? 'block' : 'none' }}>
            <div className="col column-one">
              <div className="sub-module cricket">
                <div className="content">
                  <SquadTable oppTeamPlayersLen={awayPlayersLen} team={home} />
                </div>
              </div>
            </div>
          </div>
          <div className="content-tab" style={{ display: active == 'b' ? 'block' : 'none' }}>
            <div className="col column-two">
              <div className="sub-module cricket">
                <div className="content">
                  <SquadTable oppTeamPlayersLen={homePlayersLen} team={away} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>
    )

    return homePlayersLen || awayPlayersLen ? squadTabs : <article />
  }
}

const SquadTable = ({
  team = {},
  caption,
  oppTeamPlayersLen
}) => {

  const imgString = `<img data-src="${team.logo}" class="lazyload"/> ${team.shortName}`

  const squadPlayers = (
    <tbody>
      {(team.players || []).map((p, i) => {
        return <PlayerRow key={i} player={p} />
      })}
    </tbody>
  )
  let squadNotAnnounced = []
  if (team.players.length === 0) {
    squadNotAnnounced.push(<tr key="e"><td colSpan="2" className="nya u-ta-c">Squad not yet announced</td></tr>)
    // ittrate over other team squad list to get blank <tr> markup
    for(let i=0; i<oppTeamPlayersLen - 1; i++) {
      squadNotAnnounced.push(<tr key={'e'+i}><td className="name">-</td><td className="role">-</td></tr>)
    }
  }
  return (
    <table>
        {
          (team.logo || team.shortName) && caption && <caption dangerouslySetInnerHTML={{ __html: imgString }}/>  || <caption/>
        }
        <thead>
          <tr>
            <th>PLAYER</th>
            <th className="name">ROLE</th>
          </tr>
        </thead>
          {
            // if team squad are unavailable show 'Squad not yet announced' message.
            team.players.length ? squadPlayers : (<tbody>{squadNotAnnounced}</tbody>)
          }
    </table>
  )
}

export const SquadModule = ({
  home = {},
  away = {},
  hideShowClass = true
}) => {
  const homePlayers = home.players || []
  const awayPlayers = away.players || []
  const homePlayersLen = homePlayers.length || 0
  const awayPlayersLen = awayPlayers.length || 0

  const content = (
    <div className={hideShowClass ? 'hide-show' : ''}>
      <article className="sub-module squad-table">
        <header className="bordered">
          <h1>Squad</h1>
        </header>
        <div className="table-wrap">
          <SquadTable oppTeamPlayersLen={awayPlayersLen} team={home} caption={true} />
        </div>
        <div className="table-wrap">
          <SquadTable oppTeamPlayersLen={homePlayersLen} team={away} caption={true} />
        </div>
      </article>
    </div>
  )

  return (homePlayersLen || awayPlayersLen) ? content : <article className="sub-module squad-table" style={{ display: 'none' }} />
}

export default {
  SquadModule,
  SquadTabs
}



/** WEBPACK FOOTER **
 ** ../app/components/gamepackage/cricket/Squad.jsx
 **/